/*
 * TunePad
 *
 * Michael S. Horn
 * Northwestern University
 * michael-horn@northwestern.edu
 *
 * This project was funded by the National Science Foundation (grant DRL-1612619).
 * Any opinions, findings and conclusions or recommendations expressed in this
 * material are those of the author(s) and do not necessarily reflect the views
 * of the National Science Foundation (NSF).
 */
import html from './bpm-dialog.module.html';
import { toInt } from '../../audio';

/**
 * Tempo Dialog
 */

export function showBPMDialog(tempo : number, update : (tempo : number) => void) {

    let bpm = tempo;

    const dialog = document.createElement('dialog') as HTMLDialogElement;
    dialog.innerHTML = html;
    dialog.setAttribute('tempo', `${tempo}`);
    dialog.classList.add('bpm-dialog');
    document.body.append(dialog);
    dialog.showModal();
    setTempo(tempo);

    dialog.addEventListener('click', (event) => {
        const r = dialog.getBoundingClientRect();
        const cx = event.clientX;
        const cy = event.clientY;
        if (cy < r.top || cy > r.bottom || cx < r.left || cx > r.right) {
            dialog.close();
            dialog.remove();
        }
    });

    const bpmField = dialog.querySelector('.tempo') as HTMLInputElement;
    bpmField.addEventListener('keypress', e => {
        if (e.key === "Enter") {
            bpmField.blur();
            dialog.close();
            dialog.remove();
        }
    });
    bpmField.addEventListener('input', e => {
        bpmField.value = bpmField.value.replaceAll(/[^0-9]/g, '');
    });
    bpmField.addEventListener('blur', e => {
        setTempo(toInt(bpmField.value, 100));
        update(bpm);
    });

    bindSpinnerButton(
        '.tempo-up', 
        () => { adjustTempo(1) },
        () => { update(bpm) }
    );
    bindSpinnerButton(
        '.tempo-down',
        () => { adjustTempo(-1) },
        () => { update(bpm) }
    );


    function setTempo(newBPM : number) {
        bpm = Math.max(5, Math.min(999, newBPM));
        const bpmField = dialog.querySelector('.tempo');
        if (bpmField) (bpmField as HTMLInputElement).value = `${bpm}`;
     }

    function adjustTempo(delta : number) {
        setTempo(bpm + delta);
    }
    
    /**
     * SPINNER +/- BUTTONS
     * events for the tempo buttons. we implement press and hold
     * to rapidly increase the tempo by holding the button down.
     */
    function bindSpinnerButton(selector : string, spinAction : () => void, releaseAction : () => void) {
        const button = dialog.querySelector(selector);
        let down = false;
        let hold : number | undefined = undefined;
        let release : number | undefined = undefined;
        let trigger : number | undefined = undefined;
        button?.addEventListener('pointerup', e => {
            clearInterval(hold);
            clearTimeout(release);
            clearTimeout(trigger);
            down = false;
            release = setTimeout(releaseAction, 1500);
        });
        button?.addEventListener('pointerdown', e => {
            clearInterval(hold);
            clearTimeout(release);
            spinAction();
            down = true;
            trigger = setTimeout(() => {
                hold = setInterval(() => { down ? spinAction() : clearInterval(hold) }, 50);
            }, 700);
        });
        button?.addEventListener('click', e => { e.stopImmediatePropagation() });
    }
}
